import { Injectable } from '@angular/core';
import { SystemsStatePort } from 'common/systems/application/ports/systems-state.port';
import { System } from 'common/systems/domain/resources/system.resource';
import { SystemsStore } from 'ui/features/systems/presentation/state/systems.store';

/**
 * Angular adapter that implements `SystemsStatePort` by wrapping the
 * existing `SystemsStore`, without owning any `SystemsState` or signal of
 * its own — `SystemsStore` remains the actual owner of the live state
 * (mirroring `DealsBagStoreAdapter` wrapping `DealsBagStore` for
 * `ActiveDealsBagPort`).
 */
@Injectable({ providedIn: 'root' })
export class SystemsStoreAdapter implements SystemsStatePort {
    public constructor(private readonly systemsStore: SystemsStore) {}

    public getAll(): ReadonlyArray<System> {
        return this.systemsStore.getAll();
    }

    public getById(id: string): System | undefined {
        return this.systemsStore.getById(id);
    }

    public applyUpdate(updatedSystems: ReadonlyArray<System>): void {
        this.systemsStore.applyUpdate(updatedSystems);
    }
}
